import { Search, RefreshCw, Tag } from 'lucide-react';


export default function Advantages() {
    return (
        <section className="bg-white py-16">
            <div className="mx-auto container max-w-dasha">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                    <div className="flex justify-center items-start gap-4">

                        <div className="bg-blue-100 text-blue-600 p-4 rounded-full">
                            <Search />
                        </div>
                        <div className="flex flex-col">
                            <h3 className="text-lg">One Search. All Prices.</h3>
                            <p className="text-gray-600">Compare prices across Canada — instantly</p>
                        </div>
                    </div>

                    <div className="flex justify-center items-start gap-4">
                        <div className="bg-blue-100 text-blue-600 p-4 rounded-full">
                            <RefreshCw />
                        </div>
                        <div className="flex flex-col">
                            <h3 className="text-lg">Updated Daily</h3>
                            <p className="text-gray-600">Always up-to-date — refreshed every 24h</p>
                        </div>
                    </div>

                    <div className="flex justify-center items-start gap-4">
                        <div className="bg-blue-100 text-blue-600 p-4 rounded-full">
                            <Tag />
                        </div>
                        <div className="flex flex-col">
                            <h3 className="text-lg">No Markups, Just Deals</h3>
                            <p className="text-gray-600">Find the best deal — no markups, just value</p>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}